module.exports = __webpack_public_path__ + "static/media/Suggestions.f034c308.png";